import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import i18n, { t } from "i18next";
import { toast, ToastOptions } from "react-toastify";
import { GetBackstageToken } from "../utils/store";
import { useLogin } from "../hooks/useLogin";
import { StoreKey } from "../models/cacheKey";
import { logout } from "../utils/logout";

export function BackstageLogin() {
  const [searchParams] = useSearchParams();
  const { backstageLogin } = useLogin();
  const navigate = useNavigate();

  useEffect(() => {
    const artistId = searchParams.get("artistId");
    const artistIdNum = artistId ? Number(artistId) : null;
    const partnerId = searchParams.get("partnerId");
    const partnerIdNum = partnerId ? Number(partnerId) : null;
    const lang = searchParams.get("lang");
    if (artistIdNum && partnerIdNum) {
      i18n.changeLanguage(lang || undefined);
      const sessionToken = GetBackstageToken();
      if (sessionToken) {
        backstageLogin(sessionToken, artistIdNum, partnerIdNum).then(
          (admin) => {
            navigate(
              `/events/checkins?${StoreKey.queryArtist}=${admin.artistIds[0].toString()}`,
              { replace: true },
            );
          },
        );
      } else {
        const toastOption = {
          isLoading: false,
          autoClose: 3000,
          type: "error",
          onClose: () => {
            // @ts-ignore
            logout();
          },
        } as ToastOptions;
        toast.error(t("logingate_alert_noauth"), toastOption);
      }
    }
  }, [backstageLogin, navigate, searchParams]);

  return (
    <div className={"w-full h-full flex justify-center"}>
      <div className={"loading loading-sm m-auto"}></div>
    </div>
  );
}
